var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "switch-maps@1x-a",
          d:
            "M12 0L3 7L4.63 8.27L12 14L19.36 8.27L21 7L12 0M19.37 10.73L12 16.47L4.62 10.74L3 12L12 19L21 12L19.37 10.73M19.37 15.73L12 21.47L4.62 15.74L3 17L12 24L21 17L19.37 15.73Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("use", {
      attrs: {
        fill: _vm.currentColor,
        opacity: _vm.opacity,
        "fill-rule": "evenodd",
        "xlink:href": "#switch-maps@1x-a"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }